import React, {useContext} from 'react'
import {
    ServiceRevenue,
    ServiceRevenueInput,
    useRemoveServiceRevenueMutation,
    useUpdateServiceRevenueMutation
} from "../../../../generated/graphql";
import ServiceRevenueSingleRowFormView from "./service-revenue-single-row-form-view";
import {REVENUE} from "../queries";
import {RESULT} from "../../common/result-chart/queries";
import {message} from "antd";
import {FintoolContext} from "../../../../context/fintool-context";
import {I18nContext} from "../../../../i18n";
import {MESSAGE_DURATION} from "../../../../utils/constants";

interface Props {
    serviceRevenue: ServiceRevenue
}

const ServiceRevenueSingleRowFormContainer: React.FC<Props> = ({serviceRevenue}) => {

    const [context] = useContext(FintoolContext)
    const {langCode} = useContext(I18nContext)
    const {translate} = useContext(I18nContext);

    const [updateService] = useUpdateServiceRevenueMutation({
            refetchQueries: [
                {query: REVENUE, variables: {calculationHash: context.calculationHash}},
                {query: RESULT, variables: {calculationHash: context.calculationHash}}
            ]
        }
    )
    const [removeService] = useRemoveServiceRevenueMutation({
            refetchQueries: [
                {query: REVENUE, variables: {calculationHash: context.calculationHash}},
                {query: RESULT, variables: {calculationHash: context.calculationHash}}
            ]
        }
    )

    const onChange = (values: ServiceRevenueInput) => {
        if (!!context.calculationHash) {
            updateService({
                context: {
                    language: langCode
                },
                variables: {
                    calculationHash: context.calculationHash,
                    serviceRevenueInput: values
                }
            }).then((result: any) => {
                message.success(translate("common.save.success"), MESSAGE_DURATION)
            }).catch(error => {
                message.error(error.message)
            })
        }
    }

    const onRemove = (id: string) => {
        if (!!context.calculationHash) {
            removeService({
                variables: {
                    calculationHash: context.calculationHash,
                    serviceRevenueId: id
                }
            }).then((result: any) => {
                message.success(translate("common.delete.succes"), MESSAGE_DURATION)
            }).catch(error => {
                message.error(error.message)
            })
        }
    }

    return (
        <ServiceRevenueSingleRowFormView
            serviceRevenue={serviceRevenue}
            onChangedField={onChange}
            removeServiceRevenue={onRemove}
        />
    )
}

export default ServiceRevenueSingleRowFormContainer